import { useEffect, useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listPlatesVehiclesService } from "../services/listPlatesVehicles.service";

export const usePlatesVehiclesQuery = (filters) => {
  const fetchData = useFetch();
  const [plates, setPlates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [, setRefresh] = useState(false);

  useEffect(() => {
    const fetchPlates = async () => {
      try {
        setLoading(true);
        const response = await listPlatesVehiclesService(fetchData)(filters);
        setPlates(response.data);
      } catch (error) {
        console.error("Error fetching plates:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchPlates, 500);

    debouncedFetch();

    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    plates,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
